<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <div class="wrap-img">
                    <img src="assets/images/icon-table.svg" alt="" />
                </div>
                <div class="wrap-img active">
                    <img src="assets/images/icon-play.svg" alt="" />
                </div>
                <div class="wrap-text">
                    <b> Analyze your variance </b>
                </div>
            </div>
            <div *ngIf="model" class="actions">
                <a (click)="undo()" [ngClass]="{ disabled: !model.undoAvailable }" title="Undo">
                    <img src="assets/images/icon-back.svg" alt="Undo" />
                </a>
                <a (click)="redo()" [ngClass]="{ disabled: !model.redoAvailable }" title="Redo">
                    <img src="assets/images/icon-forward.svg" alt="Redo" />
                </a>
            </div>
        </div>
    </div>
    <div [ngClass]="{ 'loading': loading, 'middle-part':true, 'middle-part_with-sidebar':true }">
        <div [ngClass]="{ 'open':showSidebar, 'sidebar':true}">
            <div class="block block-top">
                <div class="block-navigation">
                    <a class="active">
                        <svg (click)="showSidebar=!showSidebar" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 17 16" xml:space="preserve" style="enable-background: new 0 0 17 16;">
                            <style type="text/css">
                                .st0 {
                                    fill-rule: evenodd;
                                    clip-rule: evenodd;
                                    fill: #bfc0c2;
                                }
                            </style>
                            <path d="M15.6,0c0.1,0,0.2,0,0.2,0.1l1.1,1c0.1,0.1,0.1,0.3,0,0.5l-0.6,0.6l0,0c0.3,0.3,0.3,0.7,0,1l-2.1,2v6.8l2,0
            c0.3,0,0.5,0.2,0.6,0.5l0,0.1l0,0.1c-0.1,0.3-0.3,0.5-0.6,0.5l-2,0v1.9c0,0.3-0.3,0.6-0.6,0.6v0c-0.3,0-0.6-0.3-0.6-0.6v-1.9l-7.3,0
            l-1,1c-0.1,0.1-0.2,0.1-0.3,0.2l-0.1,0l-3.5,1.5l-0.1,0.1C0.6,16,0.3,16,0.1,15.9S0,15.5,0.1,15.3l0.1-0.1L1.7,12l0,0l0-0.1
            c0-0.1,0.1-0.2,0.2-0.2l1.1-1l0-6.7H1c-0.3,0-0.6-0.3-0.6-0.6C0.4,3,0.6,2.8,1,2.8h2v-2c0-0.3,0.3-0.6,0.6-0.6
            c0.3,0,0.6,0.3,0.6,0.6v2h7.1l2.2-2.1c0.3-0.3,0.8-0.3,1.1,0l0,0l0.6-0.6C15.4,0,15.5,0,15.6,0z M15.5,0.9c0,0-0.1,0-0.1,0l-0.2,0.2
            l0.6,0.6L16,1.5c0.1-0.1,0.1-0.2,0-0.2l-0.4-0.4C15.6,0.9,15.6,0.9,15.5,0.9z M14.1,1.7C14,1.7,14,1.7,14.1,1.7L3.1,12
            c0,0,0,0.1,0,0.1l1,0.9c0,0,0.1,0,0.1,0L15.1,2.8c0,0,0-0.1,0-0.1L14.1,1.7C14.1,1.7,14.1,1.7,14.1,1.7z M4.2,3.9l0,5.5l5.9-5.5H4.2
            z M13,6.4l-6.1,5.7l6.1,0V6.4z M2.6,12.9l-0.8,1.4l1.5-0.8L2.6,12.9z" class="st0"></path>
                        </svg>
                    </a>
                    <a [href]="xlsxDownloadLink" target="_blank" class="icon-download">
                        <svg version="1.1"
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 13 14" xml:space="preserve"
                            style="enable-background: new 0 0 13 14;">
                            <style type="text/css">
                                .st0 {
                                    fill-rule: evenodd;
                                    clip-rule: evenodd;
                                    fill: #bfc0c2;
                                }
                            </style>
                            <path d="M5.6,0h1.9c0.2,0,0.4,0.2,0.4,0.4v5.8h1.6l0,0l0.1,0c0.3,0,0.5,0.2,0.5,0.5C10,6.8,10,6.9,9.9,7l0,0L7,10.2
            l-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.4-0.1-0.5-0.3l0,0L3.3,7L3.2,7C3.1,6.9,3,6.8,3,6.6c0-0.3,0.2-0.5,0.5-0.5l0.1,0h1.6
            V0.4C5.2,0.2,5.4,0,5.6,0z M0,9.6h1.8v2.7h9.6V9.6H13v3.6c0,0.4-0.4,0.8-0.8,0.8H0.8C0.4,14,0,13.6,0,13.2V9.6z" class="st0"></path>
                        </svg>
                    </a>
                    <a (click)="showSidebar=false" class="close"></a>
                </div>
            </div>

            <div class="block">
                <div class="block-title block-tabs mt-0">
                    <div class="w50">
                        <a (click)="showWeightings=false" [ngClass]="{ 'active':!showWeightings }">
                            <h3>Benchmarks</h3><br>
                            <span>Select view below</span>
                        </a>
                    </div>
                    <div class="w50">
                        <a (click)="showWeightings=true" [ngClass]="{ 'active':showWeightings }">
                            <h3>Weightings</h3><br>
                            <span>Review and adjust below</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="block block-bottom">
                <div *ngIf="haveForecast()" class="block-forecast">
                    <h3>
                        Forecast adjustments <help-link helpId="99"></help-link> for
                    </h3>
                    <ul *ngIf="model" class="ellipses ellipses-root ellipses-inline">
                        <li *ngFor="let dimVal of model.displayDimensionValues">
                            <div class="ellipse" [attr.content]="dimVal.value" [style.--background-color]="dimVal.bgColor" [style.--color]="dimVal.fontColor">
                                <b class="ellipse-text">{{ dimVal.value }}</b>
                            </div>
                        </li>
                    </ul>
                </div>
                <div *ngIf="model && !showWeightings" class="block-table__benchmarks">
                    <div class="block-table">
                        <div class="table">
                            <table class="table-minimal table-minimal__extra_space">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th><span *ngIf="haveForecast()">Forecast adjustment</span></th>
                                        <th><span *ngIf="haveForecast()">{{model.outcomeName}} impact</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="border-bottom-thick">
                                        <td>
                                            <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                <li (click)="driverTypeForecastAdjustmentOutcomeClick()">
                                                    <div [attr.content]="model.outcomeName"
                                                        [ngClass]="{ 'active': (!model.formulaComponentNames || !model.formulaComponentNames.length || model.outcomeName==model.driverTypeName), 'ellipse':true, 'small':true, 'bg-white':true, 'color-gray':true, 'border-gray':true }">
                                                        <b class="ellipse-text">{{model.outcomeName}}</b>
                                                    </div>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><b *ngIf="haveForecast()"></b></td>
                                        <td [ngClass]="{ 'text-green': (!model.formulaComponentNames || !model.formulaComponentNames.length) }"><b *ngIf="haveForecast()" [title]="model.sideView.thisDimensionsComboOutcomeImpact">{{model.sideView.thisDimensionsComboOutcomeImpact | fancyNumber : outcomeImpactCtx }}</b></td>
                                    </tr>
                                    <ng-container *ngFor="let item of model.sideView.formulaComponents; let i = index">
                                        <tr class="border-bottom-dotted" [ngClass]="{ 'border-bottom':(i==model.sideView.formulaComponents.length-1 && !item.formCompAdjFromThisTab && !item.formCompAdjFromPreviousTabs) }">
                                            <td>
                                                <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                    <li (click)="driverTypeForecastAdjustmentViewItemClick(item)">
                                                        <ul class="ellipses">
                                                            <li>
                                                                <div [attr.content]="item.driverTypeName" [ngClass]="{ active:item.driverTypeName == model.driverTypeName, 'ellipse':true, 'small':true, 'bg-white':true, 'color-gray':true, 'border-gray':true }">
                                                                    <b class="ellipse-text">{{item.driverTypeName}}</b>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </td>
                                            <ng-container *ngIf="item.formulaComponentAdjustment">
                                                <td [title]="item.formulaComponentAdjustment" *ngIf="haveForecast()" [ngClass]="{ 'text-green': item.driverTypeName == model.driverTypeName }">{{item.formulaComponentAdjustment | fancyNumber: (item.formCompAdjFromThisTab ? curDriverformCompAdjCtx : formCompAdjCtx)}}</td>
                                                <td *ngIf="haveForecast()" [title]="item.outcomeImpact" [ngClass]="{ 'text-green': item.driverTypeName == model.driverTypeName }">{{item.outcomeImpact | fancyNumber : outcomeImpactCtx}}</td>
                                            </ng-container>
                                            <ng-container *ngIf="!item.formulaComponentAdjustment">
                                                <td></td>
                                                <td>Not adjusted</td>
                                            </ng-container>
                                        </tr>
                                        <tr *ngIf="item.formCompAdjFromThisTab || item.formCompAdjFromPreviousTabs" class="row-text">
                                            <td class="text-green">
                                                From this tab in sequence
                                            </td>
                                            <td [title]="item.formCompAdjFromThisTab" class="text-green">{{item.formCompAdjFromThisTab | fancyNumber: curDriverformCompAdjCtx}}</td>
                                            <td [title]="item.outcomeImpactFromThisTab" class="text-green">{{ item.outcomeImpactFromThisTab | fancyNumber : outcomeImpactCtx }}</td>
                                        </tr>
                                        <tr *ngIf="item.formCompAdjFromThisTab || item.formCompAdjFromPreviousTabs" [ngClass]="{ 'border-bottom':(i==model.sideView.formulaComponents.length-1 && item.formCompAdjFromThisTab || item.formCompAdjFromPreviousTabs), 'row-text':true }">
                                            <td class="text-green">
                                                From other tabs
                                            </td>
                                            <td [title]="item.formCompAdjFromPreviousTabs" class="text-green">{{item.formCompAdjFromPreviousTabs | fancyNumber: curDriverformCompAdjCtx}}</td>
                                            <td class="text-green">{{ item.outcomeImpactFromPreviousTabs | fancyNumber : outcomeImpactCtx }}</td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div *ngIf="model && showWeightings" class="block-table__weightings">
                    <div class="block-table">
                        <div class="table mb-16 text-left">
                            <table class="table-minimal table-minimal__extra_space">
                                <thead>
                                    <tr>
                                        <th><b>Component</b>
                                        </th>
                                        <th>Sum or<br> average</th>
                                        <th>Weight</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="border-bottom-thick">
                                        <td>
                                            <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                <li>
                                                    <div [attr.content]="model.outcomeName" class="ellipse small bg-white color-gray border-gray"><b class="ellipse-text">{{model.outcomeName}}</b></div>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><b>Sum</b></td>
                                        <td><b>None</b></td>
                                    </tr>
                                    <tr *ngFor="let formComp of model.aggregationMethods; let i = index" class="border-bottom-dotted" [ngClass]="{ 'border-bottom': i == model.aggregationMethods.length-1 }">
                                        <td>
                                            <ul class="ellipses-tree_one-select ellipses ellipses-root ellipses-tree">
                                                <li>
                                                    <ul class="ellipses">
                                                        <li>
                                                            <div [attr.content]="model.formulaComponentNames[i]"
                                                                [ngClass]="{ 'active':model.formulaComponentNames[i]==model.driverTypeName, 'ellipse':true, 'small':true, 'bg-white':true, 'color-gray':true, 'border-gray':true }">
                                                                <b class="ellipse-text">{{model.formulaComponentNames[i]}}</b>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </td>
                                        <td (click)="toggleAggregationType(formComp)" [ngSwitch]="formComp.type" class="cursor-pointer">
                                            <ng-container *ngSwitchCase="AggregationType.sum">
                                                Sum
                                            </ng-container>
                                            <ng-container *ngSwitchCase="AggregationType.average">
                                                Average
                                            </ng-container>
                                            <ng-container *ngSwitchCase="AggregationType.averageWeighted">
                                                Average
                                            </ng-container>
                                        </td>
                                        <td *ngIf="true">
                                            <mat-form-field appearance="fill" class="custom-mat-form-field">
                                                <mat-select [(value)]="formComp.columnIndex" (selectionChange)="onNumericColumnChange($event, formComp)" panelClass="custom-cdk-overlay">
                                                    <mat-option *ngFor="let col of model.numericalColumns" [value]="col.index">{{col.name}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p *ngIf="showWeightAllShortcut">
                            <a (click)="weightAllFormCompsByTheSameCol()">Weight all averaged metrics</a> by {{columnNames[lastSelectedWeightColumn]}}
                        </p>

                        <div *ngIf="isWeightsDirty" class="btn-group mt-16">
                            <button (click)="saveWeights()" class="btn btn-green btn-small">Done</button>
                            <button (click)="loadData()" class="btn btn-gray btn-small">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="main">
            <div class="top-actions">
                <div class="wrap">
                    <a *ngIf="mainfcstwalk" routerLink="/fcst-walk"
                        [queryParams]="{projectId: projectId}"
                        [state]="{ returnTabIx: returnTabIx }"
                        class="cursor-pointer">
                        <img src="assets/images/icon-cross.svg" alt="x" />
                    </a>
                    <a *ngIf="!mainfcstwalk" routerLink="/cards"
                        [queryParams]="{projectId: projectId}"
                        [state]="{ initSeqMode: seqMode, returnViewId: returnViewId, returnTabId: returnTabId }"
                        class="cursor-pointer">
                        <img src="assets/images/icon-cross.svg" alt="x" />
                    </a>
                    <a *ngIf="model" style="cursor: default!important;">
                        <img src="assets/images/icon-tab-graph.svg" />
                    </a>
                </div>
            </div>
            <div class="drivers-selection">
                <div class="drivers-selection_options">
                    <div class="view-type">
                        <a class="icon" *ngIf="seqMode" (click)="setSeqMode(false)">
                            <img src="assets/images/icon-seq.svg" alt="SEQ" />
                        </a>
                        <a class="icon" *ngIf="!seqMode" (click)="setSeqMode(true)">
                            <img src="assets/images/icon-tot.svg" alt="TOT" />
                        </a>
                        <a class="icon" *ngIf="false">
                            <img src="assets/images/icon-var-for.svg" alt="FOR" />
                        </a>
                        <a class="icon" *ngIf="false">
                            <img src="assets/images/icon-for-var.svg" alt="VAR" />
                        </a>
                        <help-link helpId="1"></help-link>
                    </div>
                </div>
                <ul *ngIf="model" class="ellipses ellipses-root ellipses-inline">
                    <li *ngFor="let dimVal of model.displayDimensionValues">
                        <div class="ellipse" [attr.content]="dimVal.value" [style.--background-color]="dimVal.bgColor" [style.--color]="dimVal.fontColor">
                            <b class="ellipse-text">{{ dimVal.value }}</b>
                        </div>
                    </li>
                    <li *ngIf="model.displayDimensionValues.length" class="divider">
                        /
                    </li>
                    <li>
                        <div class="ellipse bg-white color-gray border-gray" [attr.content]="model.driverTypeName">
                            <b class="ellipse-text">{{ model.driverTypeName }}</b>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="container">
                <div *ngIf="model" class="block-graph">
                    <div class="part-top">
                        <p>

                            Review benchmarks<span *ngIf="haveForecast()"> and adjust forecast ⓘ</span><br />
                            <small *ngIf="model && !haveAdjustments">
                                <a (click)="showWeightings=true;showSidebar=true;">Weighting settings:</a> sum up {{getSummedFormComps()}} {{(model.aggregationMethods && model.aggregationMethods.length ? 'and ' : '')}}[{{model.outcomeName}}]{{(model.aggregationMethods && model.aggregationMethods.length ? ', ' : '')}}{{getAveragedUp()}}.
                            </small>
                            <small *ngIf="model && haveAdjustments && currentForecastAdjustment && !currentForecastAdjustment.adjustmentName">
                                Total {{model.outcomeName}} {{currentForecastAdjustment.adjustmentOutcomeImpact | fancyNumber : outcomeImpactCtx}}
                            </small>
                        </p>
                    </div>
                    <div>
                        <div class="top-value">
                            <b>
                                <small>{{model.driverTypeName}} = {{diagramMaxVal | fancyNumber: diagramMinMaxCtx}}</small>
                            </b>
                        </div>
                        <div class="wrap-diagram">
                            <svg class="diagram" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                [attr.viewBox]="'0 0 ' + viewBoxWidth + ' ' + viewBoxHeight" [attr.style]="'enable-background:new 0 0 ' + viewBoxWidth + ' ' + viewBoxHeight" xml:space="preserve">
                                <polygon [attr.points]="bandTetragon" style="fill:white" />
                                <!-- <line *ngIf="linearLeftX != linearRightX" [attr.x1]="linearLeftX" [attr.y1]="linearLeftY" [attr.x2]="linearRightX" [attr.y2]="linearRightY" style="stroke:gray;stroke-width:0.5;" stroke-dasharray="10" /> -->
                                <line [attr.x1]="0" [attr.y1]="viewBoxHeight" [attr.x2]="viewBoxWidth" [attr.y2]="viewBoxHeight" style="stroke:gray;stroke-width:2" />
                                <line *ngFor="let _ of verticalGridLines; let i = index" [attr.x1]="i * xStep" y1="0" [attr.x2]="i * xStep" [attr.y2]="viewBoxHeight"
                                    style="stroke:gray;stroke-width:0.25" />
                                <line *ngFor="let _ of horizontalGridLines; let i = index" x1="0" [attr.y1]="i * (viewBoxHeight/8)" [attr.x2]="viewBoxWidth" [attr.y2]="i * (viewBoxHeight/8)"
                                    style="stroke:gray;stroke-width:0.25" />
                                <ng-container *ngFor="let series of (seqMode ? model.diagramSeriesSeq : model.diagramSeriesTot); let seriesIx = index">
                                    <ng-container *ngFor="let point of series.points; let i = index">
                                        <line *ngIf="series.points.length == 1" [attr.x1]="series.points[i].x-10" [attr.y1]="series.points[i].y" [attr.x2]="point.x+10" [attr.y2]="point.y"
                                            [attr.style]="'stroke:' + series.color + ';stroke-width:3'" />
                                        <line *ngIf="series.points.length > 1 && i<series.points.length-1" [attr.x1]="series.points[i+1].x" [attr.y1]="series.points[i+1].y" [attr.x2]="point.x"
                                            [attr.y2]="point.y" [attr.style]="'stroke:' + series.color + ';stroke-width:3'" />
                                            <polygon *ngIf="point.controlValue==model.oldControlValue && !point.canBeDeleted" [attr.points]="point.x+','+point.y+' '+(point.x-10)+','+(point.y-5)+' '+(point.x-10)+','+(point.y+5)" style="fill:#767778;stroke:#767778;stroke-width:1" />
                                            <polygon *ngIf="point.controlValue==model.newControlValue && !point.canBeDeleted" [attr.points]="point.x+','+point.y+' '+(point.x+10)+','+(point.y-5)+' '+(point.x+10)+','+(point.y+5)" style="fill:#767778;stroke:#767778;stroke-width:1" />
                                            <polygon *ngIf="point.showArrows" [attr.points]="(point.x-3)+','+(point.y-4)+' '+point.x+','+(point.y-10)+' '+(point.x+3)+','+(point.y-4)" style="fill:#50cf8a;stroke:#50cf8a;stroke-width:1" />
                                            <polygon *ngIf="point.showArrows" [attr.points]="(point.x-3)+','+(point.y+4)+' '+point.x+','+(point.y+10)+' '+(point.x+3)+','+(point.y+4)" style="fill:#50cf8a;stroke:#50cf8a;stroke-width:1" />
                                        <g (click)="pointClick(point)" class="show-on-hover">
                                            <circle [attr.cx]="point.x-pointWidth/2" [attr.cy]="point.y" r="10" [attr.stroke]="series.color" [attr.fill]="series.color" />
                                            <circle [attr.cx]="point.x+pointWidth/2" [attr.cy]="point.y" r="10" [attr.stroke]="series.color" [attr.fill]="series.color" />
                                            <rect [attr.x]="point.x-pointWidth/2" [attr.y]="point.y-11" [attr.width]="pointWidth" height="22" [attr.fill]="series.color" style="cursor:default" />

                                            <text class="point-value text" (click)="pointClick(point)" [attr.x]="point.x" [attr.y]="point.y" [attr.width]="pointWidth" height="16" fill="white"
                                                dominant-baseline="middle" text-anchor="middle" style="cursor:default">{{point.value | fancyNumber: diagramPointCtx}}</text>
                                            <text class="text" [attr.x]="point.x" [attr.y]="point.y-17" [attr.width]="pointWidth" height="16" [attr.fill]="series.color" dominant-baseline="middle"
                                                text-anchor="middle">{{point.controlValue}}</text>
                                            <text *ngIf="point.canBeDeleted && seqMode" class="btn-remove" (click)="$event.stopPropagation();removeForecastAdjust(seriesIx, i)" [attr.x]="point.x+29" [attr.y]="point.y+5"
                                                [attr.width]="pointWidth" height="16" fill="white">×</text>
                                        </g>
                                        <foreignObject *ngIf="point.editing" [attr.x]="point.x-pointWidth/2" [attr.y]="point.y-10" [attr.width]="pointWidth" height="18">
                                            <div xmlns="http://www.w3.org/1999/xhtml">
                                                <input #pointValInput [attr.ix]="i" (focusout)="applyAdjustment(seriesIx, point)" (keyup.enter)="applyAdjustment(seriesIx, point)" type="text"
                                                    [(ngModel)]="point.value" />
                                            </div>
                                        </foreignObject>
                                    </ng-container>
                                </ng-container>
                                Sorry, your browser does not support inline SVG.
                            </svg>
                        </div>
                        <div class="bottom-value">
                            <small style="font-weight: bold">
                                {{model.driverTypeName}} = {{diagramMinVal | fancyNumber: diagramMinMaxCtx}}
                            </small>
                        </div>
                    </div>
                    <div class="legends">
                        <div *ngFor="let series of model.diagramSeriesWithoutAdjusted" class="legend">
                            <svg width="30" height="10">
                                <line x1=0 y1=5 x2=30 y2=5 [attr.style]="'stroke:' + series.color + ';stroke-width:3'" />
                            </svg>
                            <span class="name">"{{series.name + series.forecastNameSuffix}}" series</span>
                        </div>
                        <div class="legend">
                            <span class="name">Variance walk:</span>
                            <svg width="10" height="10">
                                <polygon points="0,0 10,5 0,10" style="fill:#767778;stroke:#767778;stroke-width:1" />
                            </svg>
                            <span> from</span>
                            <svg class="ml-4" width="10" height="10">
                                <polygon points="10,0 0,5 10,10" style="fill:#767778;stroke:#767778;stroke-width:1" />
                            </svg>
                            <span> to</span>
                        </div>
                        <div *ngIf="showLegendForArrows" class="legend">
                            <svg width="10" height="12">
                                <polygon points="2,5 5,0 8,5" style="fill:#50cf8a;stroke:#50cf8a;stroke-width:1" />
                                <polygon points="2,7 5,12 8,7" style="fill:#50cf8a;stroke:#50cf8a;stroke-width:1" />
                            </svg>
                            <span class="name">Adjustable forecast</span>
                        </div>
                        <div *ngIf="showAdjustedForecast && adjustedSeries" class="legend">
                            <svg width="30" height="10">
                                <line x1=0 y1=5 x2=30 y2=5 [attr.style]="'stroke:' + adjustedSeries.color + ';stroke-width:3'" />
                            </svg>
                            <span class="name">Adjusted forecast</span>
                        </div>
                    </div>
                    <div *ngIf="isForecastAdjustmentDirty && seqMode" class="actions mt-16 mb-16">
                        <button *ngIf="!model.canAddCard" (click)="save()" class="btn btn-green btn-small-wide">Save</button>
                        <button *ngIf="model.canAddCard" (click)="save()" class="btn btn-green btn-small-wide">Add driver</button>
                        <button (click)="loadData()" class="btn btn-gray btn-small-wide">Cancel</button>
                    </div>
                    <div class="wrap">
                        <div *ngIf="isForecastAdjustmentDirty && model && model.haveDifferentMults" class="radio-column">
                            <form [formGroup]="form">
                                <div class="form-choice form-choice__with-icon">
                                    <input type="radio" id="strategyFrmCtrl1" formControlName="strategyFrmCtrl" name="strategyFrmCtrl"
                                           [value]="FcstAdjStrategy.Set" class="form-choice-radio">
                                    <label class="form-choice-label" for="strategyFrmCtrl1">
                                        <img src="assets/images/icon-arrow-layers.svg" width="20" />
                                        <span>Equalize underlying forecast changes</span> <help-link></help-link>
                                    </label>
                                </div>
                                <div class="form-choice form-choice__with-icon">
                                    <input type="radio" id="strategyFrmCtrl2" formControlName="strategyFrmCtrl" name="strategyFrmCtrl"
                                           [value]="FcstAdjStrategy.Scale" class="form-choice-radio">
                                    <label class="form-choice-label" for="strategyFrmCtrl2">
                                        <img src="assets/images/icon-layers.svg" width="20" />
                                        <span>Maintain underlying forecast changes</span> <help-link></help-link>
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- <div *ngIf="model && model.forecastAdjustments && model.forecastAdjustments.length" class="block-forecast">
                    <h4>Forecast adjustments status:</h4>
                    <div class="forecasts">
                        <div *ngFor="let item of model.forecastAdjustments" class="forecast">
                            <ul class="ellipses ellipses-root ellipses-inline">
                                <li *ngFor="let dimName of item.dimensions">
                                    <div [style.--background-color]="dimName.bgColor" [style.--color]="dimName.fontColor" [attr.content]="dimName.name" class="ellipse">
                                        <b class="ellipse-text">{{dimName.name}}</b>
                                    </div>
                                </li>
                                <li>
                                    <div class="divider">/</div>
                                </li>
                                <li>
                                    <div class="ellipse bg-white color-gray border-gray" [attr.content]="item.driverTypeName"><b class="ellipse-text">{{item.driverTypeName}}</b></div>
                                </li>
                            </ul>
                            <div class="results">
                                <span *ngIf="item.adjustmentName">
                                    {{item.adjustmentName}} {{item.adjustment | fancyNumber: fcstAdjustmentCtx}}, {{model.outcomeName}} {{item.adjustmentOutcomeImpact | fancyNumber: fcstAdjustmentCtx}}
                                </span>
                                <span *ngIf="!item.adjustmentName">
                                    Total {{model.outcomeName}} {{item.adjustmentOutcomeImpact | fancyNumber: fcstAdjustmentCtx}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</main>
